import { ReactElement } from 'react'

import { StyledModalContainer, StyledModalTitle, StyledModal } from './DesktopAppSuggestion.styles'
import useViewportWidth from 'hooks/useViewportWidth'
import useScrollLock from 'hooks/useScrollLock'

const DesktopAppSuggestion = (): ReactElement | null => {
  const { width } = useViewportWidth()
  const url = window.location.href

  const isNotSignupPage = !url.includes('signup')
  const isNotResourcePage = !url.includes('resources')
  const hasPathAfterBase = url.split('/').slice(3).join('/').length > 0

  const showModal = width < 900 && isNotSignupPage && hasPathAfterBase && isNotResourcePage

  useScrollLock(showModal)

  if (!showModal) return null

  return (
    <StyledModalContainer $show={showModal}>
      <StyledModal>
        <StyledModalTitle>
          For the best experience,
          <p>please use our desktop app.</p>
        </StyledModalTitle>
      </StyledModal>
    </StyledModalContainer>
  )
}

export default DesktopAppSuggestion
